module.exports = __webpack_public_path__ + "img/icon_vivo.96cab192.svg";